<template>
    <div class="text-answer">
        <h1>{{ props.question.question }}</h1>
        <div class="question-description" v-show="props.question.description">
            <p>{{ props.question.description }}</p>
        </div>
        <textarea v-model="answer" name="answer" placeholder="Ditt svar" />
        <button class="app-btn" @click="handleAnswer">Neste</button>
    </div>
</template>

<script setup>
import { defineProps, ref, defineEmits, watch } from 'vue';
import { notify } from '@kyvg/vue3-notification';
import { LocalStorageService } from '@/services/LocalStorageService';

const props = defineProps(['question']);

const localStorageService = new LocalStorageService();

const questionState = localStorageService.getQuestionState(props.question.id);

const answer = ref(questionState.userAnswer);

const emit = defineEmits(['answered']);

watch(answer, newAnswer => {
    localStorageService.updateQuestionState(props.question.id, { userAnswer: newAnswer });
});

const handleAnswer = () => {
    if (!answer.value.length) {
        return notify({ title: 'Svar', text: 'Svaret kan ikke være tomt.', type: 'error' });
    }

    emit('answered', answer.value);
};
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.text-answer {
    height: calc(100vh - 200px);
    padding: 0 5%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    textarea {
        margin: 20px 0;
        height: 100px;
        resize: none;
        width: 30%;
        font-size: 18px;
        padding: 10px;
        font-family: 'Roboto', sans-serif;
        color: $text-color;
        letter-spacing: 1px;
        border: 1px solid $primary-color;
        border-radius: 3px;
    }
}
</style>
